import type { CSSProperties, PropsWithChildren } from "react";

import { twJoin, twMerge } from "tailwind-merge";

export function Tomato({
  className,
  style,
  attention = "attention",
  children,
}: PropsWithChildren<{
  className?: string;
  style?: CSSProperties;
  attention?: "attention" | "active" | "notice";
}>) {
  return (
    <div
      className={twMerge(
        "relative inline-flex w-min grow-0 items-baseline justify-center gap-1 rounded-full p-2 font-hint whitespace-nowrap",
        attention === "attention" && "bg-attention/20 text-[hsl(from_var(--color-attention)_h_calc(s+20)_calc(l-15))]",
        attention === "active" && "bg-turtle/20 text-[hsl(from_var(--color-turtle)_h_calc(s+20)_calc(l-15))]",
        attention === "notice" && "bg-notice/20 text-[hsl(from_var(--color-notice)_h_calc(s+20)_calc(l-15))]",
        className,
      )}
      style={style}
    >
      {children && <p className="px-1">{children}</p>}
      <div className="relative">
        <div
          className={twJoin(
            "absolute size-2 rounded-full animate-duration-1000 motion-safe:animate-ping",
            attention === "attention" && "bg-attention",
            attention === "notice" && "bg-notice",
            attention === "active" && "bg-turtle",
          )}
        />
        <div
          className={twJoin(
            "size-2 rounded-full",
            attention === "attention" && "bg-attention",
            attention === "notice" && "bg-notice",
            attention === "active" && "bg-turtle",
          )}
        />
      </div>
    </div>
  );
}
